<mat-card class="termsCard">
    <mat-card-header>
        <mat-card-title>Explain's Child Endangerment Policy</mat-card-title>
        <!--        <mat-card-subtitle>Last Edited DATE</mat-card-subtitle>-->
    </mat-card-header>
    <mat-card-content>
        <b>Child Endangerment Policy</b>
        <p>Under Applicable laws, a child is defined as any person under the age of 18. Explain Market Research is
            committed to maintaining a safe and respectful environment across all online community platforms hosted on
            our app. Protecting children from exploitation, abuse, and harmful content is a top priority. This policy
            outlines our standards and procedures to prevent child endangerment and ensure compliance with the Online
            Safety Act, other applicable laws and Google Play’s and Apple’s Child Safety Standards.</p>
        <b>Scope</b>
        <p>This Policy applies to:</p>
        <ul>
            <li>All users of the Explain Online Communities App</li>
            <li>All moderators of the platform</li>
            <li>All user -generated content</li>
            <li>Any third-party partners or developers of the online community</li>
        </ul>

        <b>1. Prohibited Content and Behaviour </b>
        <p>We strictly prohibit any content or behaviour that facilitates or promotes the exploitation or abuse of
            children. Our zero-tolerance stance against this includes but is not limited to: </p>
        <ul>
            <li>Inappropriate Interaction: Any predatory behaviour targeting children, including physical or suggestive
                contact.
            </li>
            <li>Child Grooming: Attempts to befriend or establish an emotional connection with a child to facilitate
                sexual contact or exchange of sexual imagery.
            </li>
            <li>Child Trafficking: Advertising or solicitation of children for commercial sexual exploitation.</li>
            <li>Child Sexual Abuse Materials (CSAM): Any form of child sexual abuse imagery or content.</li>
            <li>Sexualization of Minors: Depictions or encouragement of sexual abuse or portrayal of children in a
                sexually exploitative manner.
            </li>
            <li>Sextortion: Threats or blackmail involving a child’s intimate images.</li>
        </ul>

        <b>2. Content Moderation and Enforcement </b>
        <p>Explain actively monitors and moderates user-generated content across all hosted online community platforms.
            Our team reviews every piece of content that is hosted on the site at the beginning and end of each working
            day. Upon obtaining actual knowledge of CSAM or other child endangerment content, our moderators will: </p>
        <ul>
            <li>Immediately remove the content from our platforms.</li>
            <li>Report child exploitation and endangerment to the Child Exploitation and Online Protection Centre (CEOP)
                and the Internet Watch Foundation (IWF).
            </li>
            <li>Suspend or terminate accounts involved in such violations.</li>
            <li>Cooperate fully with law enforcement and child protection agencies</li>
        </ul>

        <b>3. User Feedback and Reporting Mechanism </b>
        <p>Our platforms provide an in-app feedback and reporting system for users to report abusive, exploitative, or
            concerning content. Reports are reviewed promptly by our moderation team, and appropriate action is taken in
            accordance with this policy and applicable laws.
        </p>

        <b>4. Compliance and Certification </b>
        <p>We self-certify that:
            This policy is publicly accessible on all our online community platforms and explicitly prohibits child
            sexual abuse and exploitation.
        </p>
        <ul>
            <li>We provide a clear and accessible method for users to submit feedback and report concerns.</li>
            <li>We take appropriate action upon receiving actual knowledge of CSAM.</li>
            <li>We comply with all applicable child safety laws and regulations.</li>
        </ul>

        <b>5. Child Safety Point of Contact</b>
        <p>For inquiries or notifications related to child safety concerns, please contact us at:</p>
        <p>Email: <a href="mailto:info@explainresearch.co.uk">info&#64;explainresearch.co.uk</a></p>

        <b>6. Additional Restrictions</b>
        <p>Users must not</p>
        <ul>
            <li>Share content that appeals to children but contains adult themes, including excessive violence, blood,
                or gore, and harmful or dangerous activities.
            </li>
            <li>Share content that encourage prohibit bullying, hate speech, and violence.</li>
            <li>Encourage or depict self-harm, suicide or dangerous challenges involving children.</li>
            <li>Misrepresent their age or impersonate children.</li>
            <li>Share or solicit personal information from or about children.</li>

        </ul>
    </mat-card-content>
</mat-card>
